import { getLocalizedDateFormat } from 'utils/getLocalizedDateFormat';
import { Location, Order } from 'types/graphql';
import { formatFloatToText, formatHourToFloat } from 'utils';
import { DateTime } from 'luxon';

export function getShiftModalShiftJaneName(order: Order | null) {
  if (!order?.mainJane) return null;
  return `${order.mainJane.firstName} ${order.mainJane.lastName}`;
}

export function getShiftModalShiftDate(order: Order | null) {
  const timeZone = order?.timeZone?.toString();
  const { dayOfWeek, month } = getLocalizedDateFormat(order?.startAt, timeZone);

  return `${dayOfWeek}, ${month}, ${DateTime.fromISO(order?.startAt)
    .setZone(timeZone)
    .toFormat('dd, yyyy')}`;
}

export function getPositionModalShiftDate(data: Order) {
  const timeZone = data.timeZone?.toString();
  const { dayOfWeek, month } = getLocalizedDateFormat(data?.startAt, timeZone);

  return `${dayOfWeek}, ${month}, ${DateTime.fromISO(data?.startAt)
    .setZone(timeZone)
    .toFormat('dd, yyyy')}`;
}

export function getShiftModalShiftTimeRange(order: Order | null, is24HourFormat = false) {
  const timeFormat = is24HourFormat ? 'HH:mm' : 'hh:mm a';
  const timeZone = order?.timeZone?.toString();
  const startTime = DateTime.fromISO(order?.startAt).setZone(timeZone).toFormat(timeFormat);
  const endTime = DateTime.fromISO(order?.endAt).setZone(timeZone).toFormat(timeFormat);
  return `${is24HourFormat ? startTime : startTime.toLowerCase()} - ${
    is24HourFormat ? endTime : endTime.toLowerCase()
  }`;
}

export function getPositionModalShiftTimeRange(data: Order, is24HourFormat = false) {
  const timeFormat = is24HourFormat ? 'HH:mm' : 'hh:mm a';
  const timeZone = data?.timeZone?.toString();
  const startTime = DateTime.fromISO(data?.startAt).setZone(timeZone).toFormat(timeFormat);
  const endTime = DateTime.fromISO(data?.endAt).setZone(timeZone).toFormat(timeFormat);
  return `${is24HourFormat ? startTime : startTime.toLowerCase()} - ${
    is24HourFormat ? endTime : endTime.toLowerCase()
  }`;
}

export function getShiftModalShiftTotalDuration(order: Order | null) {
  const totalDuration = order?.totalDuration ?? 0;
  const breakTime = order?.orderSchedule?.breakTime ?? '00:00';
  return `${formatFloatToText(totalDuration + formatHourToFloat(breakTime))}`;
}

export function getPositionModalShiftTotalDuration(data: Order) {
  const totalDuration = data?.totalDuration ?? 0;
  const breakTime = data?.orderSchedule?.breakTime ?? '00:00';
  return `${formatFloatToText(totalDuration + formatHourToFloat(breakTime))}`;
}

export function getShiftModalScheduleId(order: Order | null) {
  if (!order?.orderSchedule?.id) throw new Error('Schedule id cannot be null');
  return order.orderSchedule.id;
}

export const formatLocation = (location: Location) => {
  const { streetNumber, street, city, state, zipCode } = location;
  return streetNumber + ' ' + street + ' ' + city + ' ' + state + ' ' + zipCode;
};
